<template>
  <div class="questionnaire" :class="{'active': isActive}" ref="questions">
    <div class="q-header">
      <div class="q-header__left" :class="{'hidden': this.$store.state.menuShown}">
        <div v-if="this.$store.state.DietImpact.dietIndexUI < questions.length + 1" class="">Question {{ this.$store.state.DietImpact.dietIndexUI + 1 }} of {{ questions.length }}</div>
        <div v-else class="">Results</div>
      </div>
      <GlobalNav/>
    </div>

      <transition name="slide-in-left" mode="">
        <Question1 v-if="this.$store.state.DietImpact.dietIndexUI == 0" key="1"/>
      </transition>
      <transition name="slide-in-left" mode="out-in">
        <Question2 v-if="this.$store.state.DietImpact.dietIndexUI == 1" key="2"/>
      </transition>
      <transition name="slide-in-left" mode="out-in">
        <Question3 v-if="this.$store.state.DietImpact.dietIndexUI == 2" key="3"/>
      </transition>
      <transition name="slide-in-left" mode="out-in">
        <Question4 v-if="this.$store.state.DietImpact.dietIndexUI == 3" key="4"/>
      </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Question1 from '@/components/Question1'
import Question2 from '@/components/Question2'
import Question3 from '@/components/Question3'
import Question4 from '@/components/Question4'
import GlobalNav from '@/components/GlobalNav'

export default {
  name: 'Questionaire',
  components: {
    Question1,
    Question2,
    Question3,
    Question4,
    GlobalNav
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState('DietImpact', ['questions']),
    isActive() {
      return this.$store.state.DietImpact.mobileQuizStarted
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../assets/styles/vars';
  .questionnaire {
  }
  .q-header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    border-bottom: 1px solid #E5EAED;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 20px;
    z-index: 9999;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    @media (min-width: 768px) {
      padding-left: 40px;
      padding-right: 40px;
    }
    &__left {
      font-family: $fSecondary;
      font-weight: $fwMed;
      color: $cOrange;
      text-transform: uppercase;
      font-size: 17px;
      line-height: 25px;
    }
  }

  .question {
    max-width: 388px;
    margin: 40px auto 0;
    padding-left: 24px;
    padding-right: 24px;
    @media (min-width: 768px) {
      max-width: 500px;
      padding-left: 40px;
      padding-right: 40px;
    }
    p {
      &.question-txt {
        font-family: $fPrimary;
        font-weight: $fwMed;
        font-size: 14px;
        line-height: 21px;
        color: $cBlack;
        margin-bottom: 20px;
        @media (min-width: 768px) {
          font-size: 15px;
        }
      }
      &.instructions {
        font-family: $fPrimary;
        font-weight: $fwReg;
        font-size: 12px;
        line-height: 16px;
        color: $cGrayTxt;
      }
    }
    &__body {
      margin-top: 34px;
    }
  }
  .question-footer {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .next-btn {
    width: 108px;
    &:hover {
      background: #ff934b;
      opacity: 1;
      transition: background 0.3s ease-in;
    }
  }
</style>
